import { FC, ReactNode } from 'react';

interface TextSliderContentProps {
  children?: ReactNode;
  translate: number;
  transition: number;
}

const TRANSLATE_MAP: Record<number, string> = {
  0: '-translate-y-0',
  32: '-translate-y-32',
  64: '-translate-y-64',
  96: '-translate-y-96',
};

const TextSliderContent: FC<TextSliderContentProps> = ({
  translate,
  children,
}) => {
  return (
    <div
      className={`mx-auto flex h-28.5 w-128 transform flex-col ${TRANSLATE_MAP[translate]} transition-transform duration-1100 ease-in-out`}
    >
      {children}
    </div>
  );
};

export default TextSliderContent;
